import { Suspense } from 'react'
import Field from '../../../../fields'
import { CERNER_ROLE_OPTIONS } from '../../TeamMemberEditForm/utils'
import { GP_CONNECT_OPTIONS, NHS_RBAC_HELPER } from '../constants'
import EditProfileCard, { CardFields, segmentedRadio } from '../EditProfileCard'

type ClinicalSystemsAccessCardProps = {
  fields: Record<string, any>
  formId: string
  gpConnectEnabled?: boolean
  cernerEnabled?: boolean
  isGroupUser?: boolean
  accountFieldsOnly?: boolean
  testId?: string
}

const ClinicalSystemsAccessCard = ({
  fields,
  formId,
  gpConnectEnabled,
  cernerEnabled,
  isGroupUser,
  accountFieldsOnly = false,
  testId
}: ClinicalSystemsAccessCardProps) => {
  if (isGroupUser) {
    return null
  }
  if (!gpConnectEnabled && !cernerEnabled) {
    return null
  }

  return (
    <EditProfileCard title="Clinical systems access" testId={testId}>
      <Suspense fallback={<div>Loading...</div>}>
        <CardFields>
          {gpConnectEnabled && (
            <Field
              formId={formId}
              keys="gpConnectPermission"
              label="GP Connect Access"
              options={GP_CONNECT_OPTIONS}
              note={NHS_RBAC_HELPER}
              required
              type="radios"
              disabled={accountFieldsOnly}
              values={fields}
              {...segmentedRadio}
            />
          )}
          {cernerEnabled && (
            <Field
              formId={formId}
              keys="cernerRole"
              label="London Care Record Access Level"
              options={CERNER_ROLE_OPTIONS}
              note={NHS_RBAC_HELPER}
              required
              type="select"
              disabled={accountFieldsOnly}
              values={fields}
            />
          )}
        </CardFields>
      </Suspense>
    </EditProfileCard>
  )
}

export default ClinicalSystemsAccessCard
